import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { SocialLoginButtonGoogleComponent } from './social-login-button.google.component';
import { Angular2SocialLoginModule } from 'angular2-social-login';
import { StoreConfigurationsService } from '../../../services/store-configurations.service';

@NgModule({
    declarations: [
        SocialLoginButtonGoogleComponent
    ],
    imports: [
        BrowserModule,
        CommonModule,
        TranslateModule,
        Angular2SocialLoginModule
    ],
    exports: [
        SocialLoginButtonGoogleComponent
    ]
})
export class SocialLoginButtonGoogleModule {
    constructor(
        protected storeConfigurations: StoreConfigurationsService
    ) {
        this.storeConfigurations.dataLoaded$.subscribe((data) => {
            let googleClientId = '822227328197-qefj62g8njutk125lehdvd38olnpd262.apps.googleusercontent.com';
            if (
                data['google-client-id'] !== undefined
                && data['google-client-id'] !== null
            ) {
                googleClientId = data['google-client-id'];
            }

            Angular2SocialLoginModule.loadProvidersScripts({
                'google': {
                    'clientId': googleClientId
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src4078178155/src/src/app/shared/components/social-login-button/google/social-login-button.google.module.ts